/*
    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequencer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

function crop(buffer, startFrame, endFrame, ctxt, leadingZeroes=0) {
    var buff = ctxt.createBuffer(buffer.numberOfChannels, leadingZeroes + endFrame - startFrame + 1, ctxt.sampleRate);
    var left = buff.getChannelData(0);

    var origLeft = buffer.getChannelData(0).subarray(startFrame, endFrame);

    left.set(origLeft, leadingZeroes);
    if (buffer.numberOfChannels > 1) {
	var right = buff.getChannelData(1);
	var origRight = buffer.getChannelData(1).subarray(startFrame, endFrame);
	right.set(origRight, leadingZeroes);
    }

    return buff;
}


export {crop};
